// Derived from https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document

let instanceCount = 1;
class ComboboxAutocomplete {
	constructor( container ) {
		this.selectElement = container.querySelector( 'select' );
		this.selectElement.setAttribute( 'aria-hidden', this.selectElement.hidden = true );

		const label = container.querySelector( 'label' );
		if ( ! label.id ) {
			label.id = `combobox-autocomplete${ instanceCount }-label`;
		}

		const wrapper = document.createElement( 'div' );
		wrapper.setAttribute( 'class', 'combobox-autocomplete js-autocomplete-select' );
		this.wrapperElement = wrapper;

		const wrapperInner = document.createElement( 'div' );
		wrapperInner.setAttribute( 'class', 'combobox-autocomplete__inner' );
		this.wrapperInnerElement = wrapperInner;

		const combobox = document.createElement( 'input' );
		combobox.setAttribute( 'class', 'combobox-autocomplete__input' );
		combobox.setAttribute( 'type', 'text' );
		combobox.setAttribute( 'role', 'combobox' );
		combobox.setAttribute( 'id', `combobox-autocomplete${ instanceCount }` );
		combobox.setAttribute( 'aria-labelledby', label.id );
		combobox.setAttribute( 'placeholder', label.innerText );
		combobox.setAttribute( 'autocomplete', 'off' );
		combobox.setAttribute( 'aria-autocomplete', 'both' );
		combobox.setAttribute( 'aria-controls', `listbox${ instanceCount }` );
		combobox.setAttribute( 'aria-expanded', 'false' );
		combobox.setAttribute( 'tabindex', '0' );
		this.comboboxNode = combobox;

		const listbox = document.createElement( 'div' );
		listbox.setAttribute( 'class', 'combobox-autocomplete__menu' );
		listbox.setAttribute( 'role', 'listbox' );
		listbox.setAttribute( 'id', `listbox-autocomplete${ instanceCount }` );
		listbox.setAttribute( 'aria-labelledby', label.id );
		listbox.setAttribute( 'tabindex', '-1' );
		this.listboxNode = listbox;

		const buttonNode = document.createElement( 'button' );
		buttonNode.setAttribute( 'type', 'button' );
		buttonNode.setAttribute( 'id', `button-autocomplete${ instanceCount }` );
		buttonNode.setAttribute( 'aria-labelledby', label.id );
		buttonNode.setAttribute( 'aria-expanded', 'false' );
		buttonNode.setAttribute( 'aria-controls', `listbox-autocomplete${ instanceCount }` );
		buttonNode.setAttribute( 'tabindex', '0' );
		this.buttonNode = buttonNode;

		label.htmlFor = combobox.id;
		wrapper.append( wrapperInner );
		wrapperInner.append( combobox );
		wrapperInner.append( buttonNode );
		wrapper.append( listbox );
		this.selectElement.parentNode.insertBefore( wrapper, this.selectElement );

		this.optionStrings = [];
		this.allOptions = [];
		this.selectElement.querySelectorAll( 'option' ).forEach( ( option, index ) => {
			this.optionStrings.push( option.textContent );
			const optionElement = this.createOption( option, index );
			this.allOptions.push( optionElement );
			this.listboxNode.appendChild( optionElement );
		} );

		// Initialize
		this.comboboxHasVisualFocus = false;
		this.listboxHasVisualFocus = false;

		this.hasHover = false;

		this.isNone = false;
		this.isList = false;
		this.isBoth = false;

		this.option = null;
		this.firstOption = null;
		this.lastOption = null;

		this.filteredOptions = [];
		this.filter = '';

		let autocomplete = this.comboboxNode.getAttribute( 'aria-autocomplete' );

		if ( typeof autocomplete === 'string' ) {
			autocomplete = autocomplete.toLowerCase();
			this.isNone = autocomplete === 'none';
			this.isList = autocomplete === 'list';
			this.isBoth = autocomplete === 'both';
		} else {
			// default value of autocomplete
			this.isNone = true;
		}

		this.comboboxNode.addEventListener(
			'keydown',
			this.onComboboxKeyDown.bind( this ),
		);
		this.comboboxNode.addEventListener(
			'keyup',
			this.onComboboxKeyUp.bind( this ),
		);
		this.comboboxNode.addEventListener(
			'click',
			this.onComboboxClick.bind( this ),
		);
		this.comboboxNode.addEventListener(
			'focus',
			this.onComboboxFocus.bind( this ),
		);
		this.comboboxNode.addEventListener( 'blur', this.onComboboxBlur.bind( this ) );

		document.body.addEventListener(
			'pointerup',
			this.onBackgroundPointerUp.bind( this ),
			true,
		);

		// initialize pop up menu

		this.listboxNode.addEventListener(
			'pointerover',
			this.onListboxPointerover.bind( this ),
		);
		this.listboxNode.addEventListener(
			'pointerout',
			this.onListboxPointerout.bind( this ),
		);

		// Traverse the element children of domNode: configure each with
		// option role behavior and store reference in.options array.

		for ( let i = 0; i < this.allOptions.length; i++ ) {
			const node = this.allOptions[ i ];

			node.addEventListener( 'click', this.onOptionClick.bind( this ) );
			node.addEventListener( 'pointerover', this.onOptionPointerover.bind( this ) );
			node.addEventListener( 'pointerout', this.onOptionPointerout.bind( this ) );
		}

		this.filterOptions();

		// Open Button

		const button = this.comboboxNode.nextElementSibling;

		if ( button && button.tagName === 'BUTTON' ) {
			button.addEventListener( 'click', this.onButtonClick.bind( this ) );
		}
		instanceCount++;
	}
	createOption( option, index ) {
		const optionElement = document.createElement( 'div' );
		optionElement.setAttribute( 'role', 'option' );
		optionElement.id = `${ this.listboxNode.id }-option${ index }`;
		optionElement.className = 'combobox-autocomplete__option';
		optionElement.innerText = option.innerText;
		optionElement.dataset.value = option.value;

		return optionElement;
	}

	getLowercaseContent( node ) {
		return node.textContent.toLowerCase();
	}

	isOptionInView( option ) {
		const bounding = option.getBoundingClientRect();
		return (
			bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <=
        ( window.innerHeight || document.documentElement.clientHeight ) &&
      bounding.right <=
        ( window.innerWidth || document.documentElement.clientWidth )
		);
	}

	setActiveDescendant( option ) {
		if ( option && this.listboxHasVisualFocus ) {
			this.comboboxNode.setAttribute( 'aria-activedescendant', option.id );
			if ( ! this.isOptionInView( option ) ) {
				option.scrollIntoView( { behavior: 'smooth', block: 'nearest' } );
			}
		} else {
			this.comboboxNode.setAttribute( 'aria-activedescendant', '' );
		}
	}

	setValue( option ) {
		this.selectElement.value = option?.value ?? '';
		this.selectElement.dispatchEvent( new Event( 'input', { bubbles: true } ) );
		this.selectElement.dispatchEvent( new Event( 'change', { bubbles: true } ) );

		this.filter = option?.textContent ?? '';
		this.comboboxNode.value = this.filter;
		this.comboboxNode.setSelectionRange( this.filter.length, this.filter.length );
		this.filterOptions();
	}

	setOption( option, flag ) {
		if ( typeof flag !== 'boolean' ) {
			flag = false;
		}

		if ( option ) {
			this.option = option;
			this.setCurrentOptionStyle( this.option );
			this.setActiveDescendant( this.option );

			if ( this.isBoth ) {
				this.comboboxNode.value = this.option.textContent;
				if ( flag ) {
					this.comboboxNode.setSelectionRange(
						this.option.textContent.length,
						this.option.textContent.length,
					);
				} else {
					this.comboboxNode.setSelectionRange(
						this.filter.length,
						this.option.textContent.length,
					);
				}
			}
		}
	}

	setVisualFocusCombobox() {
		this.listboxNode.classList.remove( 'focus' );
		this.comboboxNode.parentNode.classList.add( 'focus' ); // set the focus class to the parent for easier styling
		this.comboboxHasVisualFocus = true;
		this.listboxHasVisualFocus = false;
		this.setActiveDescendant( false );
	}

	setVisualFocusListbox() {
		this.comboboxNode.parentNode.classList.remove( 'focus' );
		this.comboboxHasVisualFocus = false;
		this.listboxHasVisualFocus = true;
		this.listboxNode.classList.add( 'focus' );
		this.setActiveDescendant( this.option );
	}

	removeVisualFocusAll() {
		this.comboboxNode.parentNode.classList.remove( 'focus' );
		this.comboboxHasVisualFocus = false;
		this.listboxHasVisualFocus = false;
		this.listboxNode.classList.remove( 'focus' );
		this.option = null;
		this.setActiveDescendant( false );
	}

	// ComboboxAutocomplete Events

	filterOptions() {
		// do not filter any options if autocomplete is none
		if ( this.isNone ) {
			this.filter = '';
		}

		let option = null;
		const currentOption = this.option;
		const filter = this.filter.toLowerCase();

		this.filteredOptions = [];
		this.listboxNode.innerHTML = '';

		for ( let i = 0; i < this.allOptions.length; i++ ) {
			option = this.allOptions[ i ];
			if (
				filter.length === 0 ||
        this.getLowercaseContent( option ).indexOf( filter ) === 0
			) {
				this.filteredOptions.push( option );
				this.listboxNode.appendChild( option );
			}
		}

		// Use populated options array to initialize firstOption and lastOption.
		const numItems = this.filteredOptions.length;
		if ( numItems > 0 ) {
			this.firstOption = this.filteredOptions[ 0 ];
			this.lastOption = this.filteredOptions[ numItems - 1 ];

			if ( currentOption && this.filteredOptions.indexOf( currentOption ) >= 0 ) {
				option = currentOption;
			} else {
				option = this.firstOption;
			}
		} else {
			this.firstOption = null;
			option = null;
			this.lastOption = null;
		}

		return option;
	}

	setCurrentOptionStyle( option ) {
		for ( let i = 0; i < this.filteredOptions.length; i++ ) {
			const opt = this.filteredOptions[ i ];
			if ( opt === option ) {
				opt.setAttribute( 'aria-selected', 'true' );
				if (
					this.listboxNode.scrollTop + this.listboxNode.offsetHeight <
          opt.offsetTop + opt.offsetHeight
				) {
					this.listboxNode.scrollTop =
            opt.offsetTop + opt.offsetHeight - this.listboxNode.offsetHeight;
				} else if ( this.listboxNode.scrollTop > opt.offsetTop + 2 ) {
					this.listboxNode.scrollTop = opt.offsetTop;
				}
			} else {
				opt.removeAttribute( 'aria-selected' );
			}
		}
	}

	getPreviousOption( currentOption ) {
		if ( currentOption !== this.firstOption ) {
			const index = this.filteredOptions.indexOf( currentOption );
			return this.filteredOptions[ index - 1 ];
		}
		return this.lastOption;
	}

	getNextOption( currentOption ) {
		if ( currentOption !== this.lastOption ) {
			const index = this.filteredOptions.indexOf( currentOption );
			return this.filteredOptions[ index + 1 ];
		}
		return this.firstOption;
	}

	/* MENU DISPLAY METHODS */

	doesOptionHaveFocus() {
		return this.comboboxNode.getAttribute( 'aria-activedescendant' ) !== '';
	}

	isOpen() {
		return this.listboxNode.style.display === 'block';
	}

	isClosed() {
		return this.listboxNode.style.display !== 'block';
	}

	hasOptions() {
		return this.filteredOptions.length;
	}

	open() {
		this.listboxNode.style.display = 'block';
		this.comboboxNode.setAttribute( 'aria-expanded', 'true' );
		this.buttonNode.setAttribute( 'aria-expanded', 'true' );
	}

	close( force ) {
		if ( typeof force !== 'boolean' ) {
			force = false;
		}

		if (
			force ||
      ( ! this.comboboxHasVisualFocus &&
        ! this.listboxHasVisualFocus &&
        ! this.hasHover )
		) {
			// this.setCurrentOptionStyle( false );
			this.listboxNode.style.display = 'none';
			this.comboboxNode.setAttribute( 'aria-expanded', 'false' );
			this.buttonNode.setAttribute( 'aria-expanded', 'false' );
			this.setActiveDescendant( false );
			this.comboboxNode.parentNode.classList.add( 'focus' );
		}
	}

	/* combobox Events */

	onComboboxKeyDown( event ) {
		let flag = false,
			altKey = event.altKey;

		if ( event.ctrlKey || event.shiftKey ) {
			return;
		}

		switch ( event.key ) {
			case 'Enter':
				if ( this.option ) {
					this.setValue( this.option );
				}
				this.close( true );
				this.setVisualFocusCombobox();
				flag = true;
				break;

			case 'Down':
			case 'ArrowDown':
				if ( this.filteredOptions.length > 0 ) {
					if ( altKey ) {
						this.open();
					} else {
						this.open();
						if (
							this.listboxHasVisualFocus ||
              ( this.isBoth && this.filteredOptions.length > 1 )
						) {
							this.setOption( this.getNextOption( this.option ), true );
							this.setVisualFocusListbox();
						} else {
							this.setOption( this.firstOption, true );
							this.setVisualFocusListbox();
						}
					}
				}
				flag = true;
				break;

			case 'Up':
			case 'ArrowUp':
				if ( this.hasOptions() ) {
					if ( this.listboxHasVisualFocus ) {
						this.setOption( this.getPreviousOption( this.option ), true );
					} else {
						this.open();
						if ( ! altKey ) {
							this.setOption( this.lastOption, true );
							this.setVisualFocusListbox();
						}
					}
				}
				flag = true;
				break;

			case 'Esc':
			case 'Escape':
				if ( this.isOpen() ) {
					this.close( true );
					this.filter = this.comboboxNode.value;
					this.filterOptions();
					this.setVisualFocusCombobox();
				} else {
					this.setValue( null );
					this.comboboxNode.value = '';
				}
				this.option = null;
				flag = true;
				break;

			case 'Tab':
				this.close( true );
				if ( this.listboxHasVisualFocus ) {
					if ( this.option ) {
						this.setValue( this.option );
					}
				}
				break;

			case 'Home':
				this.comboboxNode.setSelectionRange( 0, 0 );
				flag = true;
				break;

			case 'End':
				const length = this.comboboxNode.value.length;
				this.comboboxNode.setSelectionRange( length, length );
				flag = true;
				break;

			default:
				break;
		}

		if ( flag ) {
			event.stopPropagation();
			event.preventDefault();
		}
	}

	isPrintableCharacter( str ) {
		return str.length === 1 && str.match( /\S| / );
	}

	onComboboxKeyUp( event ) {
		let flag = false,
			option = null,
			char = event.key;

		if ( this.isPrintableCharacter( char ) ) {
			this.filter += char;
		}

		// this is for the case when a selection in the textbox has been deleted
		if ( this.comboboxNode.value.length < this.filter.length ) {
			this.filter = this.comboboxNode.value;
			this.option = null;
			this.filterOptions();
		}

		if ( event.key === 'Escape' || event.key === 'Esc' ) {
			return;
		}

		switch ( event.key ) {
			case 'Backspace':
				this.setVisualFocusCombobox();
				// this.setCurrentOptionStyle( false );
				this.filter = this.comboboxNode.value;
				this.option = null;
				this.filterOptions();
				flag = true;
				break;

			case 'Left':
			case 'ArrowLeft':
			case 'Right':
			case 'ArrowRight':
			case 'Home':
			case 'End':
				if ( this.isBoth ) {
					this.filter = this.comboboxNode.value;
				} else {
					this.option = null;
					this.setCurrentOptionStyle( false );
				}
				this.setVisualFocusCombobox();
				flag = true;
				break;

			default:
				if ( this.isPrintableCharacter( char ) ) {
					this.setVisualFocusCombobox();
					this.setCurrentOptionStyle( false );
					flag = true;

					if ( this.isList || this.isBoth ) {
						option = this.filterOptions();
						if ( option ) {
							if ( this.isClosed() && this.comboboxNode.value.length ) {
								this.open();
							}

							if (
								this.getLowercaseContent( option ).indexOf(
									this.comboboxNode.value.toLowerCase(),
								) === 0
							) {
								this.option = option;
								if ( this.isBoth || this.listboxHasVisualFocus ) {
									this.setCurrentOptionStyle( option );
									if ( this.isBoth ) {
										this.setOption( option );
									}
								}
							} else {
								this.option = null;
								this.setCurrentOptionStyle( false );
							}
						} else {
							this.close();
							this.option = null;
							this.setActiveDescendant( false );
						}
					} else if ( this.comboboxNode.value.length ) {
						this.open();
					}
				}

				break;
		}

		if ( flag ) {
			event.stopPropagation();
			event.preventDefault();
		}
	}

	onComboboxClick() {
		if ( this.isOpen() ) {
			this.close( true );
		} else {
			this.open();
		}
	}

	onComboboxFocus() {
		this.filter = this.comboboxNode.value;
		this.filterOptions();
		this.setVisualFocusCombobox();
		this.option = null;
		this.setCurrentOptionStyle( null );
	}

	onComboboxBlur() {
		this.removeVisualFocusAll();
	}

	onBackgroundPointerUp( event ) {
		if (
			! this.comboboxNode.contains( event.target ) &&
      ! this.listboxNode.contains( event.target ) &&
      ! this.buttonNode.contains( event.target )
		) {
			this.comboboxHasVisualFocus = false;
			this.setCurrentOptionStyle( null );
			this.removeVisualFocusAll();
			setTimeout( this.close.bind( this, true ), 300 );
		}
	}

	onButtonClick() {
		if ( this.isOpen() ) {
			this.close( true );
		} else {
			this.open();
		}
		this.comboboxNode.focus();
		this.setVisualFocusCombobox();
	}

	/* Listbox Events */

	onListboxPointerover() {
		this.hasHover = true;
	}

	onListboxPointerout() {
		this.hasHover = false;
		setTimeout( this.close.bind( this, false ), 300 );
	}

	// Listbox Option Events

	onOptionClick( event ) {
		this.setValue( event.target );
		this.close( true );
	}

	onOptionPointerover() {
		this.hasHover = true;
		this.open();
	}

	onOptionPointerout() {
		this.hasHover = false;
		setTimeout( this.close.bind( this, false ), 300 );
	}
}

// Initialize comboboxes

export default function setupAutocompleteDropdowns() {
	document.querySelectorAll( '.js-autocomplete-dropdown' ).forEach( widget => {
		new ComboboxAutocomplete( widget );
	} );
}
